import { render, staticRenderFns } from "./CustomFieldEdit.vue?vue&type=template&id=250bc7a4&scoped=true&"
import script from "./CustomFieldEdit.vue?vue&type=script&lang=ts&"
export * from "./CustomFieldEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250bc7a4",
  null
  
)

export default component.exports